
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CartModel } from '../../../../store/cart/cart.model';
import { Store } from '@ngrx/store';
import { selectCartData } from '../../../../store/cart/cart.selectors';
import { Product } from '../../../../core/service/cart-apis/interfaces/get-cart.interface';

@Component({
  selector: 'detail-order-checkout-tu-pedido',
  imports: [],
  templateUrl: './tu-pedido.component.html',
  styleUrl: './tu-pedido.component.css'
})
export class TuPedidoComponent implements OnInit, OnDestroy {
  productsCart: Product[] = [];
  totalAmount: number = 0;
  private subscription: Subscription = new Subscription();

  constructor(private store: Store<{ cart: CartModel }>) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectCartData).subscribe(cartData => {
        if (cartData && cartData.products) {
          this.productsCart = cartData.products;
          this.totalAmount = this.calculateTotal(this.productsCart);
          // console.log('productos de tu-pedido: ', this.productsCart);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private calculateTotal(products: Product[]): number {
    return products.reduce((total, product) => total + product.subtotal, 0);
  }
}
